define([
    "../monitoringModule"
], function (monitoringModule) {
    "use strict";

    monitoringModule.service("monitoringDashboardService", ["dashboardServiceFactory", function(dashboardServiceFactory) {
        return dashboardServiceFactory("monitoring");
    }]);
});